<script setup>

const emits = defineEmits ([
    'fn_search',
    'fn_reset'
])
</script>

<template>
  <div class="searchIconArea">
    <v-btn @click="emits('fn_search')"><v-icon>mdi-magnify</v-icon></v-btn>
    <v-btn @click="emits('fn_reset')"><v-icon>mdi-refresh</v-icon></v-btn>
  </div>
</template>

<style scoped>
  .searchIconArea{
    display: flex;
    width : 150px ;
    justify-content: space-around;
  }
  .searchIconArea div{
    margin: 10px
  }

</style>